import errorHandler from 'utils/errorHandler';
import { deslugifyParam, queryToString, slugifyArray, slugifyObject, stringToQuery } from 'utils/url';

import { fetchTagRedirects } from 'apps/tagRedirects/actions/tagRedirects';
import { getCatalogueLink } from 'apps/catalogue/links';
import ProductsPageRoute from 'apps/productsPages/utils/ProductsPageRoute';

export function getRedirectHttpStatusCode(tagMapping, customFiltersMappings, filtersMappings) {
  if (tagMapping) {
    return tagMapping.httpStatusCode;
  } else if (filtersMappings.length) {
    return filtersMappings[0].httpStatusCode;
  } else if (customFiltersMappings.length) {
    return customFiltersMappings[0].httpStatusCode;
  }

  return 302;
}

function sortFilterById(a, b) {
  return a.id - b.id;
}

export function prepareFilters({ mappings, paramName, query }) {
  const matchedMappings = [];

  if (query[paramName]) {
    const params = query[paramName].split(',').filter(param => param);
    const newCustomFilters = [];

    params.forEach(param => {
      const id = deslugifyParam(param);

      let item = {
        id,
        param,
      };

      const mapping = mappings.filtersRules[id];
      if (mapping) {
        item = {
          id: mapping.id,
          param: slugifyObject(mapping),
        };
        matchedMappings.push(mapping);
      }

      // Avoid duplicates
      if (!newCustomFilters.find(checkedItem => checkedItem.id === item.id)) {
        newCustomFilters.push(item);
      }
    });

    if (matchedMappings.length) {
      const newCustomFiltersParams = newCustomFilters
        .sort(sortFilterById) // reorder ascending (to avoid unnecessary EnforceLocation call)
        .map(item => item.param); // flatten

      query[paramName] = slugifyArray(newCustomFiltersParams); // eslint-disable-line no-param-reassign
    }
  }

  return matchedMappings;
}

export function prepareRedirectUrl({ basePath, lastTagId, location, mappings }) {
  const newLocation = {
    pathname: location.pathname,
    search: location.search,
  };

  // Replace categories
  let shouldRedirect = false;
  const tagMapping = mappings.categoriesRules[lastTagId];

  if (tagMapping) {
    newLocation.pathname = getCatalogueLink({ category: tagMapping.targetCategories }, basePath);
    shouldRedirect = true;
  }

  // Search and replace customFilters & filters
  const query = stringToQuery(location.search);

  // -> Search and replace customFilters
  const customFiltersMappings = prepareFilters({ mappings, paramName: 'customFilters', query });

  // -> Search and replace filters
  const filtersMappings = prepareFilters({ mappings, paramName: 'filters', query });

  if (customFiltersMappings.length || filtersMappings.length) {
    // Pass all unmatched customFilters and filters and other query parts through
    newLocation.search = `?${queryToString(query)}`;
    shouldRedirect = true;
  }

  if (shouldRedirect) {
    return {
      url: `${newLocation.pathname}${newLocation.search}`,
      status: getRedirectHttpStatusCode(tagMapping, customFiltersMappings, filtersMappings),
    };
  }

  return false;
}

export default function tagRedirects(nextState, replace, path, extras) {
  const { network, store } = extras;
  const { location, params } = nextState;

  const route = new ProductsPageRoute(location, params);
  const {
    basePath,
    deslugifiedParams: { tags = [] },
    deslugifiedQuery,
  } = route;
  const lastTagId = tags[tags.length - 1];

  if (!lastTagId && !deslugifiedQuery.filters && !deslugifiedQuery.customFilters) {
    return true;
  }

  const { tagRedirects: { error, isReceived, mappings } } = store.getState();
  if (error !== false) {
    return true;
  }
  if (!isReceived) {
    return new Promise((resolve, reject) => {
      const { dispatch } = store;
      dispatch(fetchTagRedirects())
        .then(() => {
          if (tagRedirects(nextState, replace, path, { network, store })) {
            resolve();
          } else {
            reject();
          }
        })
        .catch(e => {
          errorHandler(e);
          resolve();
        });
    });
  }

  const redirection = prepareRedirectUrl({ basePath, lastTagId, location, mappings });
  if (redirection) {
    network.redirectTo({ to: redirection.url, status: redirection.status });

    return false;
  }

  return true;
}
